export { Card } from './ui/Card';
export { CardWithGradient } from './ui/CardWithGradient';
export { SmallCard } from './ui/SmallCard';

export type { BgPosition, SmallCardProps, CardVariant } from './types';
